/* eslint-disable @typescript-eslint/no-useless-constructor */
import React from 'react';

import { Modal, Form, Input, Button, Space, Switch, Select, Divider } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}


export default class ProductSkuEdit extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                    width={750}
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Form.Item
                            label="SKU短码"
                            name="level"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="销售名称"
                            name="name"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="销售价格"
                            name="limitOfDeduction"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="上架状态"
                            name="limitOfBuy"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Switch checkedChildren="上架" unCheckedChildren="下架" defaultChecked={false} />
                        </Form.Item>

                        <Divider />

                        <Form.Item {...tailLayout}>
                            <Space size="large">
                                <Button onClick={this.cancelModal}>取消</Button>
                                <Button type="primary" htmlType="submit">确认提交</Button>
                            </Space>

                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

